import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";

const BranchNode = memo(({ data, selected }) => {
  const conditions = data.conditions || [];
  return (
    <div
      style={{
        background: "#fff",
        border: `2px solid ${selected ? "#1a1a1a" : "#ff9800"}`,
        borderRadius: 4,
        padding: 0,
        minWidth: 100,
        boxShadow: selected ? "0 0 0 2px rgba(0,0,0,0.15)" : "0 1px 3px rgba(0,0,0,0.08)",
        transform: "rotate(0deg)",
        cursor: "pointer",
      }}
    >
      <Handle type="target" position={Position.Left} style={{ background: "#ff9800", width: 8, height: 8 }} />

      {/* Header */}
      <div style={{
        background: "#fff3e0", padding: "6px 10px",
        borderBottom: "1px solid #ffe0b2", borderRadius: "2px 2px 0 0",
        display: "flex", alignItems: "center", gap: 4,
      }}>
        <span style={{ fontSize: 12 }}>&#9670;</span>
        <span style={{ fontWeight: 600, fontSize: 11, color: "#e65100" }}>
          {data.label || data.field || "Branch"}
        </span>
      </div>

      {/* Condition outputs */}
      <div style={{ padding: "4px 10px 6px" }}>
        {conditions.map((cond, i) => (
          <div
            key={cond.value}
            style={{
              display: "flex", alignItems: "center", justifyContent: "space-between",
              fontSize: 10, color: "#555", padding: "2px 0",
              position: "relative",
            }}
          >
            <span>{cond.label || cond.value}</span>
            <Handle
              type="source"
              position={Position.Right}
              id={cond.value}
              style={{
                background: "#ff9800", width: 6, height: 6,
                top: "auto", position: "relative", right: -4,
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
});

BranchNode.displayName = "BranchNode";
export default BranchNode;
